import React from 'react';

import { useBooleanState } from '@lumapps/lumx-hooks/hooks/useBooleanState';
import { SocialNetworks } from '@lumapps/sa-social-networks/types';

export function useLoadSocialNetworkShareDialog() {
    const [isOpen, , onClose, open] = useBooleanState(false);
    const [activeSocialNetwork, setActiveSocialNetwork] = React.useState<SocialNetworks>();
    const handleSetActiveSocialNetwork = React.useCallback(
        (socialNetwork: SocialNetworks) => {
            setActiveSocialNetwork(socialNetwork);
            open();
        },
        [open],
    );
    return { isOpen, activeSocialNetwork, handleSetActiveSocialNetwork, onClose };
}
